import React from "react";
import {
  CircularProgress,
  FormControl,
  InputLabel,
  Link,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import { StyledH3 } from "../../../common/components/Title/styles";
import { useState } from "react";
import { useEffect } from "react";
import { getFiles } from "../../../api/caseApi";
import { StyledDataGrid } from "../../../common/components/DataGrid/styles";
import { normalizeDateTime } from "../../../common/helpers/normalizeDateTime";
import { API_URL } from "../../../config";
import { Box } from "@mui/system";
import { Tooltip } from "@mui/material";
import { StyledButton } from "../../../common/components/Button";
import FilePreviewDialog from "./FilePreviewDialog";
import { useNavigate } from "react-router-dom";
import UploadFilesDialog from "./UploadFilesDialog";
import { isCaseProgressDone } from "../../../common/helpers/isCaseProgressDone";
import isCaseTerminated from "../../../common/helpers/isCaseTerminated";
import { Dialog } from "@mui/material";
const types = {
  1: "Ios Scan",
  2: "Clinical Photography",
  3: "Additional File",
  4: "Design File",
  5: "Additional on Reject",
};

const subTypes = {
  1: {
    1: "Maxillary",
    2: "Mandibular",
    3: "Bite Scan",
  },
  2: {
    1: "Full Face",
    2: "Full Face Smiling",
    3: "Profile Of Face",
    4: "Occluded Bucal View of Anterior",
    5: "Occluded Bucal View of Right Lateral",
    6: "Occluded Bucal View of Left Lateral",
    7: "Occlusal View of Upper",
    8: "Occlusal View of Lower",
  },
};

const UploadedFilesContainer = ({ caseDetails }) => {
  const navigate = useNavigate();
  // alert(JSON.stringify(caseDetails));
  const [files, setFiles] = useState([]);
  const [type, setType] = useState(0);
  const [openFilePreview, setOpenFilePreview] = useState(false);
  const [openFileUpload, setOpenFileUpload] = useState(false);

  const [currentFileUrl, setCurrentFileUrl] = useState("");
  const [currentFilename, setCurrentFilename] = useState("");

  const [scanningId, setScanningId] = useState(null);
  const [designId, setDesignId] = useState(null);
  const [reviewDesignId, setReviewDesignId] = useState(null);

  const isUploadFilesEnabled = isCaseProgressDone("For scanning", caseDetails);
  const handleCloseFilePreview = () => {
    setOpenFilePreview(false);
  };

  const handleCloseFileUpload = () => {
    setOpenFileUpload(false);
  };

  const handleOpenSlideShow = () => {
    const designFiles = rows.filter((a) => a.type === "Design File");
    if (designFiles.length > 0) {
      navigate(`slide-show`, { state: designFiles });
    }
  };
  const fetchFiles = async () => {
    const response = await getFiles(caseDetails.id);
    setFiles(response.data.files);
  };
  useEffect(() => {
    caseDetails.caseProgressions.forEach((c) => {
      if (c.type === "Scanning") {
        setScanningId(c.id);
      } else if (c.type === "Design") {
        setDesignId(c.id);
      } else if (c.type === "Review Design") {
        setReviewDesignId(c.id);
      }
    });

    fetchFiles();
  }, [caseDetails]);

  const columns = [
    {
      field: "fileName",
      headerName: "Filename",
      flex: 2,
      renderCell: (params) => (
        <Tooltip title={params.value}>
          <span>{params.value}</span>
        </Tooltip>
      ),
    },
    {
      field: "type",
      headerName: "File Type",
      flex: 2,
      renderCell: (params) => (
        <Tooltip title={params.value}>
          <span>{params.value}</span>
        </Tooltip>
      ),
    },
    {
      field: "subType",
      headerName: "Type",
      flex: 2,
      renderCell: (params) => (
        <Tooltip title={params.value}>
          <span>{params.value}</span>
        </Tooltip>
      ),
    },
    {
      field: "createdDate",
      headerName: "Date",
      flex: 2,
      renderCell: (params) => {
        return [<div>{normalizeDateTime(params.value)}</div>];
      },
    },
    {
      field: "id",
      headerName: "Action",
      flex: 2,
      renderCell: (params) => {
        return [
          <StyledButton
            theme="green"
            marginRight="5px"
            onClick={() => {
              setOpenFilePreview(true);
              setCurrentFileUrl(API_URL + `file/${params.value}/download`);
              setCurrentFilename(params.row.fileName);
            }}
          >
            Preview
          </StyledButton>,
          <StyledButton
            theme="green"
            href={API_URL + `file/${params.value}/download`}
            target="_blank"
            rel="noopener noreferrer"
          >
            Download
          </StyledButton>,
        ];
      },
    },
  ];

  const rows = files
    .sort((a, b) => {
      if (a.type < b.type) return -1;
      if (a.type > b.type) return 1;
      else return 0;
    })
    .map((file) => ({
      ...file,
      type: types[file.type],
      subType: file.subType > 0 ? subTypes[file.type][file.subType] : "",
    }))
    .filter((file) => {
      if (type === 0) {
        return file;
      }

      return file.type === types[type];
    });

  return (
    <div>
      <UploadFilesDialog
        open={openFileUpload}
        onClose={handleCloseFileUpload}
        caseId={caseDetails.id}
        scanningId={scanningId}
        designId={designId}
        reviewDesignId={reviewDesignId}
        fetchFiles={fetchFiles}
      />
      <FilePreviewDialog
        openFilePreview={openFilePreview}
        handleCloseFilePreview={handleCloseFilePreview}
        url={currentFileUrl}
        filename={currentFilename}
      />
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <StyledH3 theme="lightpurple">Uploaded Files</StyledH3>
        {isUploadFilesEnabled && !isCaseTerminated(caseDetails) && (
          <StyledButton
            width={"150px"}
            style={{ marginLeft: "10px" }}
            theme="green"
            onClick={() => setOpenFileUpload(true)}
          >
            Upload Files
          </StyledButton>
        )}
        {!isCaseTerminated(caseDetails) &&
          isCaseProgressDone("Design in progress", caseDetails) && (
            <StyledButton
              style={{ minWidth: "130px", marginLeft: "5px" }}
              theme="green"
              onClick={handleOpenSlideShow}
            >
              3D Slideshow
            </StyledButton>
          )}
      </div>
      <Box maxWidth="sm">
        <FormControl fullWidth>
          <InputLabel id="file-type-label">File Type</InputLabel>
          <div
            style={{
              display: "flex",
              width: "100%",
              alignItems: "center",
            }}
          >
            <Select
              labelId="file-type-label"
              id="file-type-select"
              label="File Type"
              value={type}
              onChange={(e) => setType(e.target.value)}
              style={{ width: "100%" }}
            >
              <MenuItem value={0}>All</MenuItem>
              {Object.keys(types).map((typeNumber) => (
                <MenuItem value={+typeNumber}>{types[typeNumber]}</MenuItem>
              ))}
            </Select>
          </div>
        </FormControl>
      </Box>

      <StyledDataGrid
        autoHeight
        rows={rows}
        columns={columns}
        pageSize={10}
        rowsPerPageOptions={[]}
      />
    </div>
  );
};

export default UploadedFilesContainer;
